module.exports = __webpack_public_path__ + "img/Achsvermessung_784x514.5451b5c7.jpg";